document.querySelector(".filters-group")?.addEventListener("input", (e) => {
  const checkbox = e.target as HTMLInputElement;

  if (checkbox.name === "searchFiltersViewAll" && checkbox.checked) {
    checkbox
      .closest(".filters")
      ?.querySelectorAll('[name="searchFilters[]"]')
      .forEach((el) => ((el as HTMLInputElement).checked = false));
  } else {
    // deselect 'View All' if we select another option
    if (checkbox.checked) {
      (checkbox
        .closest(".filters")!
        .querySelector(
          "[name=searchFiltersViewAll]"
        ) as HTMLInputElement)!.checked = false;
    }

    // select 'View All' if no options are checked
    if (
      !checkbox
        .closest(".filters")!
        .querySelector('[name="searchFilters[]"]:checked')
    ) {
      (checkbox
        .closest(".filters")!
        .querySelector(
          "[name=searchFiltersViewAll]"
        ) as HTMLInputElement)!.checked = true;
    }
  }

  filterJobListings();
});

const filterListingsByUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const filters = urlParams.getAll("filter");

  for (const filter of filters) {
    const input = document.querySelector<HTMLInputElement>(
      `[name="searchFilters[]"][value="${filter}"]`
    );

    if (input) {
      input.checked = true;

      // deselect 'View All' if an option is found
      (input
        .closest(".filters")!
        .querySelector(
          "[name=searchFiltersViewAll]"
        ) as HTMLInputElement)!.checked = false;
    }
  }

  filterJobListings();
};

const filterJobListings = () => {
  const filter = () => {
    const filters = getSelectedFilters();
    const lowerCaseFilters = filters.map((filter) => filter.toLowerCase());

    const jobListings = document.querySelectorAll<HTMLElement>(
      ".job-listings__listing"
    );

    // update url to new filters
    updateFiltersUrl();

    if (!filters.length) {
      for (const listing of jobListings) {
        listing.style.display = "block";
      }

      return;
    }

    for (const listing of jobListings) {
      if (
        !lowerCaseFilters.includes(
          listing.dataset.jobDepartment?.toLowerCase()!
        )
      ) {
        listing.style.display = "none";
      } else {
        listing.style.display = "block";
      }
    }
  };

  if (
    !document.startViewTransition ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    filter();
    return;
  }

  document.startViewTransition(filter);
};

const getSelectedFilters = (): string[] => {
  return [
    ...document.querySelectorAll<HTMLInputElement>(
      '[name="searchFilters[]"]:checked'
    ),
  ].map((el) => el.value);
};

const updateFiltersUrl = (): string => {
  const filters = getSelectedFilters();

  const url = new URL(window.location.href);
  url.searchParams.delete("filter");
  for (const filter of filters) {
    url.searchParams.append("filter", filter);
  }

  const urlString = url.toString();
  window.history.replaceState({}, "", urlString);

  return urlString;
};

filterListingsByUrl();

export {
  filterJobListings,
  getSelectedFilters,
  filterListingsByUrl,
  updateFiltersUrl,
};
